/** @deprecated use tokens instead @soluto-private/aui-tokens */
export const space = {
  25: '.125rem',
  50: '.25rem',
  75: '.375rem',
  100: '.5rem',
  150: '.75rem',
  200: '1rem',
  300: '1.5rem',
  400: '2rem',
  500: '2.5rem',
  600: '3rem',
  800: '4rem',
  1000: '5rem',
  1200: '6rem'
};